@if (!loading()) {
  <div class="custom-question-wrapper">
    <div class="header">
      <span> Create your own question </span>
    </div>
    <div class="create-question-wrapper">
      @if (isChangingInfo) {
        <form [formGroup]="badgingForm" class="create-question">
          <mat-form-field class="badging-form w-full" appearance="outline">
            <mat-label>Field name</mat-label>
            <input matInput type="text" formControlName="title" />
            <mat-error>{{ getErrorMessage('title') }}</mat-error>
          </mat-form-field>
          <mat-form-field class="badging-form w-full" appearance="outline">
            <mat-label>Your question</mat-label>
            <input matInput type="text" title="question" formControlName="description" />
            <mat-error>{{ getErrorMessage('description') }}</mat-error>
          </mat-form-field>
          <mat-form-field class="welcome-custom-select-input w-full" appearance="outline">
            <mat-label>Type</mat-label>
            <mat-select formControlName="inputType">
              @for (option of questionType; track option.text) {
                <mat-option [value]="option.value">{{ option.text }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (isInputTypeSelect) {
            <mat-form-field class="badging-form w-full" appearance="outline">
              <mat-label>Add options</mat-label>
              <mat-chip-grid #chipGrid aria-label="Enter fruits">
                @for (option of singleMultiSelectOptions; track option) {
                  <mat-chip-row
                    [editable]="true"
                    (removed)="removeOption(option)"
                    (edited)="editOption(option, $event)"
                  >
                    {{ option }}
                    <button type="button" matChipRemove [attr.aria-label]="'remove ' + option">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                }
                <input
                  matInput
                  type="text"
                  formControlName="option"
                  maxlength="{{ maxOptionLength }}"
                  [matChipInputFor]="chipGrid"
                  (matChipInputTokenEnd)="addOption($event)"
                  [matChipInputAddOnBlur]="true"
                />
                <mat-error>{{ getErrorMessage('option') }}</mat-error>
              </mat-chip-grid>
            </mat-form-field>
          }
          <mat-form-field class="welcome-custom-select-input w-full" appearance="outline">
            <mat-label>Required</mat-label>
            <mat-select formControlName="required">
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="welcome-custom-select-input w-full" appearance="outline">
            <mat-label>Featured</mat-label>
            <mat-select formControlName="featured">
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      }
      @if (!isChangingInfo && _customQuestions.length) {
        @for (question of _customQuestions; track question.title; let i = $index) {
          <div class="question-item">
            <span title="{{ question.title }}">
              {{ question.title ?? '' | truncate: 45 }}
            </span>
            <button (click)="startEditing(i)">
              <mat-icon> edit </mat-icon>
            </button>
            <button (click)="removeItem(i)">
              <mat-icon> delete </mat-icon>
            </button>
          </div>
        }
      }
      <span class="warning-text">
        You are prohibited from soliciting confidential personal information such as but not limited to credit card
        information, social security numbers, etc, in your registration questions.
      </span>
      @if (!isChangingInfo) {
        <button class="main-button primary-button" (click)="isCreating.set(!isCreating())">
          Create custom question
        </button>
      } @else {
        <div class="form-button">
          <button class="main-button text-button" (click)="resetForm()">Cancel</button>
          <button class="main-button form-submit-button" [disabled]="badgingForm.invalid" (click)="submitForm()">
            {{ buttonText }}
          </button>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="flex justify-center w-full">
    <app-loading></app-loading>
  </div>
}
